
function BackIcon({
	color = "#000",
	size = 14,
	direction = "left",
}: {
	color?: string;
	size?: number;
	direction?: "left" | "right";
}) {
	return (
		<svg
			height={size}
			width={size}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			style={{ transform: `rotate(${direction === "left" ? 0 : 180}deg)` }}
		>
			<g fill={color}>
				<polygon fill={color} points="6.7,14.7 8.1,13.3 3.8,9 16,9 16,7 3.8,7 8.1,2.7 6.7,1.3 0,8 " />
			</g>
		</svg>
	);
}

export default BackIcon;
